export enum HingeType {
  normal = 'Normal',
  normalNotRising = 'NormalNotRising',
  chrome = 'Chrome',
}
